// The tutor's linked-student directory: a stable order and, only where display
// names collide, a secondary identity that tells the students apart without
// printing a full address: a masked email, plus the connected date if the masks
// still match.

export const maskEmail = (email) => {
  const match = typeof email === "string" && email.trim().match(/^([^\s@]+)@([^\s@]+\.[^\s@]+)$/);
  if (!match) return "";
  return `${match[1].slice(0, Math.min(2, match[1].length - 1) || 1)}•••@${match[2]}`;
};

const connectedLabel = (link) => {
  const value = link.respondedAt || link.requestedAt;
  const date = typeof value === "string" ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return `connected ${new Intl.DateTimeFormat(undefined, { year: "numeric", month: "short", day: "numeric" }).format(date)}`;
};

export const displayName = (link) => link.counterpartDisplayName || link.counterpartEmail || "A student";

const nameKey = (name) => name.trim().toLocaleLowerCase();

// Sorted by name (case- and accent-insensitive), ties in the server's order.
export const directoryEntries = (links) => {
  const rows = (Array.isArray(links) ? links : []).filter(Boolean)
    .map((link, index) => ({ link, index, id: link.studentUserId || null, name: displayName(link), secondary: "" }));
  const byName = new Map();
  rows.forEach((row) => byName.set(nameKey(row.name), [...(byName.get(nameKey(row.name)) || []), row]));
  byName.forEach((group) => {
    if (group.length < 2) return;
    group.forEach((row) => { row.secondary = maskEmail(row.link.counterpartEmail); });
    const counts = new Map();
    group.forEach((row) => counts.set(row.secondary, (counts.get(row.secondary) || 0) + 1));
    group.forEach((row) => {
      if (counts.get(row.secondary) < 2) return;
      row.secondary = [row.secondary, connectedLabel(row.link)].filter(Boolean).join(" · ");
    });
  });
  return rows.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }) || a.index - b.index);
};
